import { motion } from "framer-motion";
import { Clock, IndianRupee, ShieldCheck, Zap, Award } from "lucide-react";

export const AtAGlanceBox = ({ vertical }) => {
  const investmentRange = vertical?.investment_range;
  const totalDuration = vertical?.total_duration;

  const items = [];

  if (investmentRange) {
    items.push({
      icon: IndianRupee,
      label: "Investment Range",
      value: investmentRange,
      color: "text-emerald-600",
      bgColor: "bg-emerald-50",
      borderColor: "border-emerald-200",
    });
  }

  if (totalDuration) {
    items.push({
      icon: Clock,
      label: "Implementation Time",
      value: totalDuration,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200",
    });
  }

  // Only show if we have at least investment or duration
  if (items.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-3"
      data-testid="at-a-glance-box"
    >
      <div className="grid grid-cols-2 gap-3">
        {items.map((item, index) => (
          <div
            key={item.label}
            className={`p-4 rounded-xl ${item.bgColor} border ${item.borderColor}`}
            data-testid={`glance-item-${index}`}
          >
            <div className="flex items-center gap-2 mb-1.5">
              <item.icon className={`w-4 h-4 ${item.color}`} />
              <span className="text-[11px] font-medium text-slate-500 uppercase tracking-wide">{item.label}</span>
            </div>
            <p className={`text-base font-bold ${item.color}`}>{item.value}</p>
          </div>
        ))}
      </div>

      {/* Trust Badge */}
      <div className="flex items-center gap-2 text-sm text-slate-500 px-1">
        <Award className="w-4 h-4 text-amber-500 flex-shrink-0" />
        <span>200+ Successful MSME Implementations</span>
      </div>
    </motion.div>
  );
};
